module.exports = __webpack_public_path__ + "static/media/09_4.b18bbbdb.png";